import { useState } from "react";
import Pagination from "react-js-pagination";
import "./style.scss";

export default (props) => {
    return (
        <div className={"pagination-wrapper relative " + props.className}>
            <div className="result-count">{props.totalItemsCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} Results</div>
            {
                props.totalItemsCount >= props.itemsCountPerPage && 
                <Pagination firstPageText="1" lastPageText={ Math.ceil(props.totalItemsCount / props.itemsCountPerPage).toString()} nextPageText="..." prevPageText="..." {...props} />
            }
        </div>
    )
};